var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.98,
    y: 1,
    width: 8.02,
    height: 17.819,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 10,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#CBFF88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.063,
    y: 22.125,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.063 13.902h21V19l-2.75 2.812-3.063 3.313H19.062V13.902z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.13 18.25V4.87H22.87v18.26h13.38a.435.435 0 110 .87H22.436a.435.435 0 01-.435-.435V4.435c0-.24.195-.435.435-.435h19.13c.24 0 .435.195.435.435V18.25a.435.435 0 01-.87 0z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.993 12.63l2.881 2.88 7.133-7.131a.435.435 0 11.614.614l-7.44 7.44a.435.435 0 01-.614 0l-3.189-3.188a.435.435 0 01.615-.615zM41.565 17.816a.435.435 0 01.308.742l-5.314 5.315a.435.435 0 01-.743-.308v-5.314c0-.24.195-.435.435-.435h5.314zm-4.88 4.7l3.83-3.83h-3.83v3.83z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-lg-survey-c771ca87e975d7e2da1eb88c8ddeaf1b.svg";
export { SvgAiLgSurvey as ReactComponent };